var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5L0 5.95455V14.1364C0 21.7045 5.33333 28.7818 12.5 30.5C19.6667 28.7818 25 21.7045 25 14.1364V5.95455L12.5 0.5ZM15.9722 16.3045L17.2222 21.5955L12.5 18.8L7.77778 21.5955L9.02778 16.3182L4.86111 12.7864L10.3611 12.3227L12.5 7.34545L14.6389 12.3091L20.1389 12.7727L15.9722 16.3045Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.92e13b3628ce19ffc853e4de2ee6d720.svg";
export { ForwardRef as ReactComponent };